import {
  accountStore,
  IUserSubAccount,
  UserSubAccountType,
} from "entities/account";
import { sessionStore } from "entities/session/model/sessionModel";
import { useEffect, useState } from "react";
import { useStore } from "zustand";

const useSubAccount = () => {
  const { subAccountSubNumber } = useStore(sessionStore);
  const { subAccounts } = useStore(accountStore);
  const [subAccount, setSubAccount] = useState<null | IUserSubAccount>(null);

  useEffect(() => {
    setSubAccount(
      subAccounts.find(
        (subAccount) => String(subAccount.id) === subAccountSubNumber
      ) || null
    );
  }, [subAccountSubNumber, subAccounts]);

  const isMarginSubAccount =
    subAccount && subAccount?.type === UserSubAccountType.Margin;

  const isTmSubAccount =
    subAccount && subAccount?.type === UserSubAccountType.TrustManagement;

  const canTrade = !isMarginSubAccount && !isTmSubAccount;

  return { subAccount, isMarginSubAccount, isTmSubAccount, canTrade };
};

export default useSubAccount;
